// PillButton — mesma assinatura do botão do dashboard, escopo do domínio Client.
// Variant solid: 1 por tela (DESIGN_SYSTEM §componentes/Buttons).

import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react';

import { cn } from '@control-center/ui';

interface PillButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  solid?: boolean;
  icon?: ReactNode;
  danger?: boolean;
}

export const PillButton = forwardRef<HTMLButtonElement, PillButtonProps>(function PillButton(
  { solid, icon, danger, className, children, type = 'button', ...rest },
  ref,
) {
  if (danger) {
    return (
      <button
        ref={ref}
        type={type}
        className={cn(
          'inline-flex items-center gap-2 rounded-[10px] border border-bad/60 px-3 py-[7px] text-[12px] font-medium text-red-200 transition-colors hover:border-bad hover:bg-bad/10',
          'disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        {...rest}
      >
        {icon}
        <span>{children}</span>
      </button>
    );
  }
  if (solid) {
    return (
      <button
        ref={ref}
        type={type}
        style={{ color: '#09090b' }}
        className={cn(
          'inline-flex items-center gap-2 rounded-[10px] border border-ink bg-ink px-3 py-[7px] text-[12px] font-medium transition-colors hover:bg-ink-2',
          'disabled:cursor-not-allowed disabled:opacity-60 disabled:hover:bg-ink',
          className,
        )}
        {...rest}
      >
        {icon}
        <span>{children}</span>
      </button>
    );
  }
  return (
    <button
      ref={ref}
      type={type}
      className={cn(
        'inline-flex items-center gap-2 rounded-[10px] border border-line px-3 py-[7px] text-[12px] font-medium text-ink-2 transition-colors hover:border-line-2 hover:bg-panel-2',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...rest}
    >
      {icon}
      <span>{children}</span>
    </button>
  );
});
